<div class="dialog-header">
  <mat-icon class="dialog-back" (click)="$event.stopPropagation(); tryClose('back')">chevron_left</mat-icon>
  <span class="dialog-title">{{ isEdit ? 'Ansprechperson bearbeiten' : 'Ansprechperson hinzufügen' }}</span>
  <mat-icon class="dialog-close" (click)="$event.stopPropagation(); tryClose(null)">close</mat-icon>
</div>
<div class="dialog-body">
  <label class="field-label">Name*</label>
  <input class="field-input" [class.field-error]="form.controls['contact_name'].invalid && form.controls['contact_name'].touched"
         [formControl]="$any(form.controls['contact_name'])">
  @if (form.controls['contact_name'].invalid && form.controls['contact_name'].touched) {
    <p class="validation-error">Name ist ein Pflichtfeld.</p>
  }

  <label class="field-label">Funktion</label>
  <input class="field-input" [formControl]="$any(form.controls['contact_function'])">

  <label class="field-label">Bereich</label>
  <select class="field-input" [formControl]="$any(form.controls['contact_area'])" (change)="onAreaChange(form.controls['contact_area'].value)">
    <option value="">Kein Bereich</option>
    @for (area of contactAreas; track area) {
      <option [value]="area">{{ area }}</option>
    }
  </select>

  @if (showCustomArea) {
    <label class="field-label">Eigene Bezeichnung*</label>
    <input class="field-input" [class.field-error]="form.controls['custom_area'].invalid && form.controls['custom_area'].touched"
           [formControl]="$any(form.controls['custom_area'])">
    @if (form.controls['custom_area'].invalid && form.controls['custom_area'].touched) {
      <p class="validation-error">Eigene Bezeichnung ist ein Pflichtfeld.</p>
    }
  }

  <label class="field-label">Rufnummer</label>
  <input class="field-input" [formControl]="$any(form.controls['contact_phone'])">

  <label class="field-label">E-Mail</label>
  <input class="field-input" type="email" [class.field-error]="form.controls['contact_email'].invalid && form.controls['contact_email'].touched"
         [formControl]="$any(form.controls['contact_email'])">
  @if (form.controls['contact_email'].hasError('email') && form.controls['contact_email'].touched) {
    <p class="validation-error">Bitte gib eine gueltige E-Mail-Adresse ein.</p>
  }

  <label class="field-label">Notiz</label>
  <textarea class="field-input" [formControl]="$any(form.controls['contact_note'])" rows="3"></textarea>
</div>
<div class="dialog-footer">
  <button class="dialog-save-btn" (click)="save()" [disabled]="form.invalid">Speichern</button>
</div>
